import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'components/'
import styles from './AppliedFilters.module.scss'

const AppliedFilters = ({ filters, handleClear }) => (
  <div className={styles.filters}>
    {filters.map(filter => (
      <span className={styles.tag}>
        {filter.name}
        <button
          aria-label={`Limpar filtro de ${filter.name}`}
          type="button"
          onClick={handleClear(filter.icon)}
          className={styles.button}
        >
          <Icon color="darkColor" type="clear" size={16} />
        </button>
      </span>
    ))}
  </div>
)

AppliedFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleClear: PropTypes.func.isRequired,
}

export default React.memo(AppliedFilters)
